import { Box, Typography, Button } from '@mui/material';
import { AddOutlined } from '@mui/icons-material';

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
  icon?: React.ReactNode;
}

/**
 * EmptyState - Component displayed when no data is available
 * Shows a helpful message and call-to-action button
 */
export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  icon,
}: EmptyStateProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: 2,
        p: 4,
      }}
    >
      {icon}
      <Typography variant="h5" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center" maxWidth="400px">
        {description}
      </Typography>
      <Button
        variant="contained"
        startIcon={<AddOutlined />}
        onClick={onAction}
      >
        {actionLabel}
      </Button>
    </Box>
  );
}
